import React from 'react';
import Post from '../components/Post';
import { initialPosts } from '../data/posts';

function Home() {
  return (
    <div className="home-page feed-page">
      <div style={{ maxWidth: '800px', margin: '0 auto', paddingTop: '20px', paddingBottom: '40px' }}>
        
        {initialPosts.map((post, index) => (
          <Post key={post.id} post={post} style={{ animationDelay: `${index * 0.1}s` }} />
        ))}
      </div>
    </div>
  );
}

export default Home;
